export const LOGO_URL = "https://customer-assets.emergentagent.com/job_b32a9d06-cd1a-4936-8a74-34f0d65c7ad3/artifacts/t9kdcc0c_ACDT_logo_800x520.jpg";

export const NAV_ITEMS = [
  { label: "Home", href: "/#home" },
  { label: "Chi Siamo", href: "/#chi-siamo" },
  { label: "Corso", href: "/corso" },
  { label: "Pacchetti", href: "/#pacchetti" },
  { label: "Opportunità Extra", href: "/opportunita-extra" },
  { label: "Direttivo & Doc", href: "/direttivo-documentazione" },
  { label: "Registro Nazionale", href: "/registro-nazionale" },
  { label: "Eventi", href: "/eventi" },
  { label: "Blog & News", href: "/blog" },
  { label: "Tesseramento", href: "/#tesseramento" },
  { label: "Team", href: "/#team" },
  { label: "Stampa & Eventi", href: "/#rassegna-stampa" },
  { label: "Dona", href: "/#dona" },
  { label: "Contatti", href: "/#contatti" },
];

export const HERO_BENEFITS = [
  {
    title: "Corsi e percorsi di formazione riconosciuti",
    text: "Programmi formativi strutturati e certificati, pensati per sviluppare competenze digitali, tecnologiche e di sostenibilità realmente applicabili nel mondo del lavoro e nelle imprese.",
  },
  {
    title: "Tesseramento ufficiale e badge digitale",
    text: "Iscrizione all'associazione con rilascio di tessera ufficiale e badge digitale, utilizzabili per attestare competenze. L'iscrizione al registro consente di firmare i servizi prestati con dotazione del timbro ufficiale e di essere riconosciuti come figura professionale grazie all'appartenenza alla rete ACDT.",
  },
  {
    title: "Collaborazione diretta con imprese e partner",
    text: "Connessione con aziende, professionisti e realtà partner per progetti concreti, opportunità di crescita, sperimentazione sul campo e sviluppo di relazioni professionali qualificate.",
  },
];

export const FEATURES = [
  {
    icon: "GraduationCap",
    title: "Formazione digitale certificata",
    text: "Percorsi formativi strutturati e riconosciuti per sviluppare competenze digitali, tecnologiche e di sostenibilità, pensati per professionisti e aziende che vogliono crescere in modo consapevole.",
  },
  {
    icon: "BadgeCheck",
    title: "Tesseramento e identità digitale ACDT",
    text: "Tessera ufficiale e badge digitale che certificano la tua appartenenza alla rete ACDT, garantendo riconoscibilità e credibilità professionale nel settore.",
  },
  {
    icon: "ShieldCheck",
    title: "Tutela Digitale",
    text: "Strumenti di tutela e supporto per i consumatori digitali, garantendo protezione, consapevolezza e sicurezza nell'utilizzo delle tecnologie e dei servizi online.",
  },
  {
    icon: "Cpu",
    title: "Competenze applicate al mondo reale",
    text: "Conoscenze concrete su AI, blockchain, automazione e processi digitali, applicate a casi reali per migliorare efficienza, controllo e capacità decisionale.",
  },
  {
    icon: "Network",
    title: "Rete professionale e collaborazione attiva",
    text: "Accesso a una rete qualificata di imprese, partner e professionisti per creare sinergie, sviluppare progetti condivisi e generare nuove opportunità di valore.",
  },
  {
    icon: "Leaf",
    title: "Sostenibilità e innovazione",
    text: "Promuoviamo una cultura digitale orientata alla sostenibilità ambientale, sociale ed economica, integrando innovazione tecnologica e responsabilità.",
  },
];

export const SPECIALIZZAZIONI = [
  "Consulente Digitale Tecnologico",
  "Consulente Software in abbonamento Trading",
  "Consulente Editoriale Digitale e Marketing",
  "Consulente in innovazione",
  "Consulente Eco-Sostenibilità / Bio-Sostenibilità",
  "Consulente in promozione e sviluppo IA",
  "Consulente Ecommerce / Shop / Dropshipping",
  "Consulente Di Viaggio Online",
];

export const CERTIFICATIONS = [
  {
    title: "MIMIT – Legge 4/2013",
    image: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/cert-1.jpg",
    text: "Ente iscritto nell'elenco dell'aggregazione del Ministero dello Sviluppo Economico delle associazioni non ordinistiche che rilasciano l'attestato di qualità dei servizi erogati dagli aderenti (art.2, comma 7 della legge 4/2013) tramite Centro Esse Studi.",
  },
  {
    title: "Centro Studi E.S.S.E.",
    image: "https://customer-assets.emergentagent.com/job_acdt-hub/artifacts/iau77wq9_ESSE%20STUDI.jpeg",
    text: "Forma Aggregativa di Associazioni Professionali (Ministero delle Imprese e del Made in Italy). Supporto Scientifico e Formativo.",
  },
  {
    title: "Pigreco Formazione",
    image: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/cert-2.jpg",
    text: "Eccellenza nella didattica professionale. Partner Formativo ufficiale per percorsi di alta formazione e specializzazione. I corsi, su richiesta, possono ottenere il riconoscimento dei CFU (Crediti Formativi Universitari) grazie all'accreditamento di Pigreco con l'Università degli Studi di Napoli Federico II.",
  },
];

export const PACKAGES = [
  {
    id: "tessera",
    name: "Tessera Associativa",
    tagline: "Entra nella community ACDT",
    price: 50,
    total: 50,
    items: [
      { label: "Tessera associativa ACDT", price: 50 },
      { label: "Consulenza Tutela Digitale base", price: 0, free: true },
    ],
    features: [
      "Iscrizione ufficiale all'Associazione",
      "Badge digitale ACDT",
      "Consulenza Tutela Digitale base inclusa",
      "Accesso area riservata socio",
      "Canale WhatsApp riservato",
      "Convenzioni e vantaggi soci",
    ],
    accent: false,
    bonificoCausale: "Tesseramento ACDT - Nome e Cognome",
  },
  {
    id: "tessera-corso",
    name: "Tessera + Corso",
    tagline: "Forma le tue competenze digitali",
    price: 149,
    total: 149,
    items: [
      { label: "Tessera associativa ACDT", price: 50 },
      { label: "Corso A.C.D.T. per la qualificazione professionale per Consulenti Digitali Tecnologici e di Sostenibilità", price: 99 },
      { label: "Consulenza Tutela Digitale base", price: 0, free: true },
    ],
    features: [
      "Tutto ciò che include la Tessera",
      "Corso A.C.D.T. per la qualificazione professionale completo (20 ore)",
      "Consulenza Tutela Digitale base inclusa",
      "Attestato di partecipazione",
      "Materiale didattico digitale",
      "Affiancamento con docenti esperti",
    ],
    accent: true,
    badge: "Più scelto",
    bonificoCausale: "Tesseramento ACDT - Nome e Cognome / Acquisto Corso Consulente e Consumatore Digitale Base",
  },
  {
    id: "premium",
    name: "Tessera + Corso + Registro",
    tagline: "Professione + Registro Nazionale",
    price: 218.9,
    total: 218.9,
    items: [
      { label: "Tessera associativa ACDT", price: 50 },
      { label: "Corso A.C.D.T. per la qualificazione professionale per Consulenti Digitali Tecnologici e di Sostenibilità", price: 99 },
      { label: "Iscrizione al Registro Nazionale accreditato all'aggregazione MIMIT per Consulenti ed Educatori Digitali Tecnologici e di Sostenibilità", price: 69.9 },
      { label: "Consulenza Tutela Digitale base", price: 0, free: true },
    ],
    features: [
      "Tutto ciò che include Tessera + Corso",
      "Iscrizione al Registro Nazionale Agg. MIMIT",
      "Consulenza Tutela Digitale base inclusa",
      "Timbro ufficiale + Carta intestata",
      "Riconoscimento ex Legge 4/2013",
      "Possibilità di firma servizi professionali",
      "Accesso a Masterclass dedicate",
    ],
    accent: false,
    badge: "Professionista",
    bonificoCausale: "Tesseramento ACDT - Nome e Cognome / Acquisto Corso Consulente e Consumatore Digitale Base / Iscrizione registro Nazionale Educatori e Consulenti Digitali",
  },
];

export const ADDONS = [
  {
    id: "tutela",
    name: "Tutela Digitale",
    short: "Protezione del consumatore digitale",
    price: 29.9,
    features: [
      "Assistenza in caso di truffe online e phishing",
      "Supporto per identità digitale e dati personali",
      "Consulenza GDPR e diritti del consumatore",
      "Sportello dedicato per segnalazioni",
      "Tutela contrattuale su servizi digitali",
    ],
  },
];

export const PAYMENT_METHODS = [
  { id: "paypal", label: "PayPal", desc: "Paga in un'unica soluzione o rateizza in 3, 6 o 12 rate", icon: "Paypal", rateable: true },
  { id: "googlepay", label: "Google Pay", desc: "Paga con il tuo account Google", icon: "GooglePay" },
  { id: "applepay", label: "Apple Pay", desc: "Paga con Touch ID o Face ID", icon: "ApplePay" },
  { id: "klarna", label: "Klarna", desc: "Paga in 3, 6 o 12 rate senza interessi", icon: "Wallet", rateable: true },
  { id: "bonifico", label: "Bonifico bancario", desc: "Coordinate IBAN ACDT", icon: "Building" },
];

export const TESSERAMENTO = {
  title: "Tesseramento all'associazione",
  intro:
    "L'iscrizione all'associazione ACDT è possibile a coloro il cui iter formativo e/o professionale sia verificabile e rispondente ai requisiti definiti dall'Associazione. L'iscrizione comporta il rispetto delle norme statutarie, del Codice di Condotta e del Codice Deontologico, l'obbligo di seguire le linee guida.",
  blocks: [
    {
      heading: "Quota Sociale",
      subheading:
        "La quota sociale per l'iscrizione all'associazione ACDT è regolata dall'articolo 6, comma 2 dello Statuto.",
      items: [
        "Ha validità annuale e scade dopo 365 giorni dalla data di iscrizione.",
        "Per il rinnovo è sufficiente effettuare il pagamento del rinnovo direttamente dalla propria Area Riservata.",
      ],
    },
    {
      heading: "Costi per l'iscrizione",
      subheading: "Quota annuale",
      price: "€ 50,00",
      items: [
        "Compilare, in tutte le sue parti, la domanda d'iscrizione.",
        "Consulenza Tutela Digitale base inclusa per tutti i soci.",
      ],
    },
    {
      heading: "Rinnovo iscrizione",
      subheading: "La quota per l'iscrizione agli anni successivi è sempre di € 50.",
      items: [
        "Per rinnovare è sufficiente pagare il rinnovo nella propria Area Riservata.",
        "La validità della nuova annualità decorre dalla data di rinnovo per ulteriori 365 giorni.",
      ],
    },
  ],
};

export const REGISTRO = {
  title: "Iscrizione al Registro",
  intro:
    "L'iscrizione al Registro CONSULENTI ED EDUCATORI DIGITALI TECNOLOGICI E DI SOSTENIBILITÀ è possibile a coloro il cui iter formativo e/o professionale sia verificabile e rispondente ai requisiti definiti dall'Associazione. L'iscrizione comporta il rispetto delle norme statutarie, del Codice di Condotta e del Codice Deontologico, l'obbligo di seguire le linee guida e l'obbligo di aggiornamento permanente.",
  blocks: [
    {
      heading: "Quota Sociale",
      subheading:
        "La quota sociale per l'iscrizione al Registro ACDT è regolata dall'articolo 6, comma 2 dello Statuto.",
      items: [
        "Ha validità annuale e scade dopo 365 giorni dalla data di iscrizione.",
        "Per il rinnovo è sufficiente effettuare il pagamento del rinnovo direttamente dalla propria Area Riservata.",
      ],
    },
    {
      heading: "Costi per l'iscrizione",
      subheading: "Quota annuale per iscritti al Registro",
      price: "€ 69,90",
      items: [
        "Per coloro che hanno acquisito il titolo dopo aver concluso il Corso di Alta Formazione per Consulente Digitale Tecnologico e di Sostenibilità o altrimenti aver effettuato un totale di 20 ore di corsi sul Digitale, Tecnologia, Sostenibilità con validazione del Consiglio Direttivo dell'Associazione.",
        "Consulenza Tutela Digitale base inclusa.",
      ],
    },
    {
      heading: "Rinnovo iscrizione",
      subheading: "La quota per gli anni successivi è sempre di € 69,90.",
      items: [
        "Per rinnovare è sufficiente pagare il rinnovo nella propria Area Riservata.",
        "È obbligatorio aver conseguito nell'anno 20 ore di corsi tramite l'associazione con il rilascio dei Crediti Formativi Digitali Tecnologici (CFDT) o tramite corsi degli enti partner.",
      ],
    },
  ],
  benefits: [
    "Accesso a Masterclass tematiche su Scuole e Aziende per condividere competenze e programmare attività con tutti gli Educatori del Registro.",
    "Formazione specifica online e offline e informazioni utili per approfondire i temi del proprio profilo di specializzazione.",
    "Partecipazione ad eventi: seminari, convegni, workshop, corsi e-learning e blended learning, rivista scientifica ed e-book specialistici.",
    "Possibilità di usufruire di tutti i servizi offerti da ACDT.",
    "Far parte di una comunità di persone motivate e attive in settori che promuovono la crescita e l'evoluzione delle persone.",
    "Ricezione di Carta Intestata e Timbro ufficiale per operare la libera professione come Consulente Digitale Tecnologico e di Sostenibilità.",
  ],
};

export const TEAM = [
  { name: "Michele Roccaro", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-roccaro.jpg" },
  { name: "Luca Milardi", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-minardi.jpg" },
  { name: "Giovanni Sapuppo", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-sapuppo.jpg" },
  { name: "Marco Bilancia", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-bilancia.jpg" },
  { name: "Davide Campanella", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-campanella.jpg" },
  { name: "Simona Baracico", photo: "https://digitaltechsolutions.it/wp-content/uploads/2026/03/team-barracico.jpg" },
];

export const STATS = [
  { value: "500+", label: "Soci attivi" },
  { value: "20+", label: "Corsi certificati" },
  { value: "15", label: "Partner istituzionali" },
  { value: "100%", label: "Programma riconosciuto" },
];

export const CONTACT = {
  org: "A.C.D.T. – Associazione Consulenti e Consumatori Digitali",
  address: "Via Giordano Cavestro, 1 – 97019 Vittoria (RG)",
  cf: "01878490885",
  piva: "01878490885",
  phone: "+39 377 366 0476",
  email: "acdt@centrostudiesse.it",
  website: "www.assoacdt.com",
  whatsappChannel: "https://whatsapp.com/channel/0029VbBfXBf30LKKtlaKG12P",
  whatsappDirect: "https://api.whatsapp.com/send?phone=+393773660476",
  iscrizione: "https://server.esserete.it/fmi/webd/Esse_Gestionale?script=iscrizionesocioweb&param=B0196",
  accessoSoci: "https://server.esserete.it/EsseOrganizer.html",
  loginCorsi: "https://portale.digitaltechsolutions.biz/login",
  statutoPdf: "https://customer-assets.emergentagent.com/job_acdt-hub/artifacts/ybtn3xep_atto%20e%20statuto%20new.pdf",
  bank: {
    holder: "A.C.D.T. – Associazione Consulenti e Consumatori Digitali",
    bank: "UniCredit",
    iban: "IT44S0200843641000107397100",
    paese: "IT",
    cinEu: "44",
    cinIt: "S",
    abi: "02008",
    cab: "43641",
    cc: "000107397100",
    bic: "UNCRITM1K20",
  },
  donationIban: "IT44S0200843641000107397100",
  donationBank: "UniCredit",
  donationHolder: "A.C.D.T. – Associazione Consulenti e Consumatori Digitali",
  airc: "https://donazione.airc.it/?_gl=1*1ax1804*_up*MQ..*_ga*NDEzMDU2MTcyLjE3ODE3MzA4MTg.*_ga_LHV7BFH9WN*czE3ODE3MzA4MTckbzEkZzAkdDE3ODE3MzA4MTckajYwJGwwJGgxMzQyMTk5Njcy",
};


export const COURSE = {
  title: "Consulente Digitale Tecnologico e di Sostenibilità",
  subtitle: "Corso A.C.D.T. per la qualificazione professionale del Consulente Digitale, Tecnologico e di Sostenibilità",
  description:
    "Un percorso formativo strutturato, riconosciuto e tutelante per chi vuole operare nel mondo digitale, tecnologico e della sostenibilità con metodo, competenza e inquadramento professionale.",
  price: 99,
  withTessera: 149,
  premium: 218.9,
  hero: "https://digitaltechsolutions.it/wp-content/uploads/2025/09/CORSO-Consulente-Digitale-Tecnologico-e-di-Sostenibilita-1024x683.webp",
  image2: "https://digitaltechsolutions.it/wp-content/uploads/2025/09/CORSO-Consulente-Digitale-Tecnologico-e-di-Sostenibilita2-1024x683.webp",
  image3: "https://digitaltechsolutions.it/wp-content/uploads/2025/09/corso1-1024x683.webp",
  meta: [
    { k: "Durata", v: "20 ore" },
    { k: "Struttura", v: "20 moduli progressivi" },
    { k: "Normativa", v: "Legge 14/01/2013, n. 4" },
    { k: "Supporto Scientifico", v: "Centro Studi E.S.S.E." },
    { k: "Partner Formativo", v: "Pigreco S.r.l." },
    { k: "Modalità", v: "Online + materiali riservati" },
    { k: "CFP / CFU", v: "Riconoscibili • Univ. Federico II" },
    { k: "CFDT", v: "Crediti per aggiornamento al Registro" },
  ],
  modules: [
    { n: 1, title: "Introduzione e contesto associativo A.C.D.T.", text: "Inquadramento del corso, finalità istituzionali di A.C.D.T., scenario della trasformazione digitale e sostenibile." },
    { n: 2, title: "La figura del Consulente e Consumatore Digitale", text: "Definizione del profilo professionale, ambiti di intervento, limiti operativi e compatibilità con altre professioni." },
    { n: 3, title: "Etica, responsabilità e tutela nel mondo digitale", text: "Principi etici, responsabilità professionale, tutela del cittadino e del consumatore digitale." },
    { n: 4, title: "Identità digitale: SPID, CIE e strumenti di accesso", text: "Strumenti di identificazione digitale, livelli di sicurezza e supporto all'utenza." },
    { n: 5, title: "Firma digitale e Posta Elettronica Certificata (PEC)", text: "Validità giuridica, utilizzo corretto e assistenza a cittadini e imprese." },
    { n: 6, title: "Pubblica Amministrazione Digitale e servizi online", text: "Accesso e utilizzo dei servizi digitali della PA (INPS, Agenzia Entrate, ANPR, PagoPA, App IO)." },
    { n: 7, title: "Sicurezza informatica di base e rischi digitali", text: "Rischi più comuni, truffe online, buone pratiche di protezione e consapevolezza digitale." },
    { n: 8, title: "Privacy e protezione dei dati personali (GDPR)", text: "Principi del GDPR, diritti dell'interessato e ruolo del consulente nella tutela dei dati." },
    { n: 9, title: "Strumenti di comunicazione e organizzazione digitale", text: "Uso professionale di videoconferenze, calendari digitali e gestione degli appuntamenti." },
    { n: 10, title: "Operatività del Consulente Digitale", text: "Gestione del rapporto con l'utente, analisi dei bisogni, orientamento e tracciabilità." },
    { n: 11, title: "Educazione e alfabetizzazione digitale", text: "Cittadinanza digitale, contrasto al divario digitale e supporto a famiglie e soggetti fragili." },
    { n: 12, title: "Tecnologie emergenti e Intelligenza Artificiale", text: "Introduzione all'IA, opportunità, rischi e utilizzo consapevole degli strumenti intelligenti." },
    { n: 13, title: "Sostenibilità digitale, tecnologica e ambientale", text: "Impatto ambientale delle tecnologie e buone pratiche di sostenibilità applicata al digitale." },
    { n: 14, title: "Modelli di consulenza e opportunità professionali", text: "Consulenza autonoma, collaborazioni, sportelli digitali e reti professionali." },
    { n: 15, title: "Registro Professionale A.C.D.T. e inquadramento normativo", text: "Funzionamento del Registro, requisiti di iscrizione, diritti e doveri dell'iscritto." },
    { n: 16, title: "Certificazione, attestazione e riconoscibilità professionale", text: "Valore dell'attestato A.C.D.T. come certificazione di competenza ai sensi della L. 4/2013." },
    { n: 17, title: "Aggiornamento professionale continuo e crediti formativi", text: "Formazione permanente, obblighi di aggiornamento e criteri per il mantenimento dell'iscrizione." },
    { n: 18, title: "Organizzazione, gestione e compliance del consulente", text: "Gestione documentale, procedure operative e rapporti con enti e istituzioni." },
    { n: 19, title: "Deontologia professionale e controllo qualità", text: "Vigilanza interna, segnalazioni, procedure disciplinari e tutela dell'utenza." },
    { n: 20, title: "Conclusione del corso, verifica finale e accesso al Registro", text: "Riepilogo competenze, verifica finale, rilascio attestato e avvio del percorso professionale." },
  ],
  whyNeeded: [
    "Nessun riconoscimento formale",
    "Assenza di tutela professionale",
    "Confusione normativa",
    "Scarsa credibilità verso clienti ed enti",
    "Esposizione a responsabilità e contenziosi",
  ],
  solutions: [
    "Tutelare chi opera e chi utilizza il digitale",
    "Fornire un metodo operativo chiaro",
    "Creare un inquadramento professionale serio",
    "Formare professionisti consapevoli",
  ],
  outcomes: [
    "Conoscenza dei diritti del consumatore digitale",
    "Capacità di riconoscere pratiche scorrette e clausole rischiose",
    "Tutela di identità digitale e dati personali",
    "Metodo per valutare servizi, offerte e piattaforme online",
    "Competenze utili nella vita privata e professionale",
  ],
  audience: [
    "Consulenti Digitali",
    "Professionisti e Imprenditori",
    "Formatori ed Educatori",
    "Freelance e Networker",
    "Cittadini digitali consapevoli",
    "Chi vuole costruire una nuova professionalità",
  ],
  topics: [
    "Ecosistema digitale, tecnologico e sostenibile",
    "Diritti e doveri del professionista digitale",
    "Sicurezza, identità digitale e responsabilità",
    "Metodo operativo e visione professionale",
    "Tutela del consulente e del consumatore",
    "Posizionamento e credibilità professionale",
  ],
  includes: [
    "Materiali didattici inclusi",
    "Attestato finale di qualificazione professionale",
    "Accesso a contenuti riservati",
    "Tesseramento A.C.D.T. incluso",
    "Crediti Formativi (CFP)",
    "CFU riconoscibili • Univ. Federico II (su richiesta tramite Pigreco)",
    "Possibilità iscrizione al Registro",
  ],
  faqs: [
    {
      q: "Questo corso è riconosciuto ufficialmente?",
      a: "Sì. Il corso è strutturato in coerenza con la Legge 4/2013, che disciplina le professioni non organizzate in ordini o collegi. Al termine viene rilasciato un attestato di qualificazione e, su richiesta, è possibile accedere al Registro dei Professionisti di Categoria.",
    },
    {
      q: "Che valore hanno i Crediti Formativi Professionali (CFP) e i CFU?",
      a: "I CFP certificano l'attività formativa svolta e rappresentano un riconoscimento formale delle competenze acquisite. Inoltre, su richiesta, i corsi possono ottenere il riconoscimento dei CFU (Crediti Formativi Universitari) grazie all'accreditamento di Pigreco con l'Università degli Studi di Napoli Federico II. Sono utili per la formazione continua e per rafforzare il profilo professionale.",
    },
    {
      q: "A chi è rivolto il corso?",
      a: "Il corso è rivolto a consulenti digitali e tecnologici, professionisti e imprenditori, freelance, formatori e operatori del settore, e a chi desidera costruire una nuova professionalità nel digitale. Non è richiesto un titolo specifico.",
    },
    {
      q: "Il corso abilita automaticamente alla professione?",
      a: "Il corso fornisce un percorso di qualificazione professionale conforme alla normativa vigente, con attestato finale, CFP e possibilità di iscrizione al Registro. L'esercizio della professione avviene sempre nel rispetto delle competenze acquisite e delle normative applicabili.",
    },
    {
      q: "Cosa ottengo al termine del percorso?",
      a: "Al completamento del corso ottieni: attestato di qualificazione, Crediti Formativi Professionali (CFP), tesseramento A.C.D.T. incluso, accesso al Registro Professionale (su richiesta), materiali didattici e contenuti riservati.",
    },
  ],
};
